import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

async function ListarBackupService(idUsuario) {
    try {
        return await instance.Backend.post(
            "/Backup/Listar",
            { idUsuario },
            customConfig
        );
    } catch (error) {
        console.log(error);
        return null;
    }
}

export { ListarBackupService };
